export default {
  // supplier-meta.tsx
  "Add a supplier": "Ajouter un fournisseur",
  Name: "Nom",
  "Business ID": "ID Entreprise",
  Email: "E-mail",
  Phone: "Téléphone",
  Country: "Pays",
  "Creation Date": "Date de Création",
  Actions: "Actions",
  Active: "Actif",
  Inactive: "Inactif",
  Pending: "En Attente",

  // supplier-form.tsx
  "Supplier Name": "Nom du Fournisseur",
  "Shop ID": "ID Boutique",
  Address: "Adresse",
  City: "Ville",
  Region: "Région",

  // Modals
  "Create a new supplier": "Créer un nouveau fournisseur",
  "Edit Supplier": "Modifier le Fournisseur",
  "View Supplier": "Voir le Fournisseur",
  "Do you really want to delete this Supplier?":
    "Voulez-vous vraiment supprimer ce Fournisseur ?",
  "Confirm Deletion": "Confirmer la Suppression",
  "General Informations": "Informations Générales",
  "Metadata & Timestamps": "Métadonnées et Horodatages",
  "Created On": "Créé le",
  "Updated On": "Mis à jour le",

  // Blocks & Table
  Suppliers: "Fournisseurs",
  "Add Supplier": "Ajouter un Fournisseur",
  "Update Supplier": "Mettre à jour le Fournisseur",
  "Supplier Details": "Détails du Fournisseur",
  "No Supplier selected": "Aucun Fournisseur sélectionné",
  Submit: "Soumettre",
  Supplier: "Fournisseur",
  "Search supplier by name, email or business ID":
    "Rechercher un fournisseur par nom, email ou identifiant d'entreprise",
  "Edit Selection": "Modifier la sélection",
  "No suppliers found": "Aucun fournisseur trouvé",
  "Phone number": "Numéro de téléphone",
  "Warning: This action is irreversible and may lead to cascade deletions.":
    "Attention : cette action est irréversible et peut entraîner des suppressions en cascade.",
  Cancel: "Annuler",
};
